import React from 'react'
import Button, { ButtonProps } from '@material-ui/core/Button/Button'
import theme from '@/theme'
import makeStyles from '@material-ui/core/styles/makeStyles'

const styles = {
    root: {
        backgroundColor: theme.colors.white,
        border: `solid 1px ${theme.colors.border}`,
        borderRadius: 10,
        padding: '5px 11px',
        fontSize: 11,
    },
    disabled: {
        backgroundColor: theme.colors.grey,
        boxShadow: 'unset',
        color: `${theme.colors.white} !important`,
    },
}

const DefaultButton = (props: ButtonProps & { component?: string }) => {
    const defaultClasses = makeStyles(styles)()
    const { classes, ...otherProps } = props
    return (
        <Button classes={{ ...defaultClasses, ...classes }} {...otherProps} disableRipple>
            {props.children}
        </Button>
    )
}

export default DefaultButton

export const AccentButton = (props: ButtonProps) => {
    const { root, ...otherStyles } = styles
    const defaultClasses = makeStyles({
        root: {
            ...root,
            backgroundColor: theme.colors.accent,
            color: theme.colors.white,
            textTransform: 'none',
            '&:hover': {
                backgroundColor: theme.colors.accent,
            },
        },
        ...otherStyles,
    })()
    const { classes, ...otherProps } = props
    return (
        <Button classes={{ ...defaultClasses, ...classes }} {...otherProps}>
            {props.children}
        </Button>
    )
}
